module.exports = __webpack_public_path__ + "img/icon_sub_arrow.2001669e.svg";